import React from 'react'
import classNames from 'classnames'
import {Link} from '../'

class DocToc extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const className = classNames("DocToc sr4  ", this.props.className);

    return (
      <div className={className}>
        <div className="toc">
          <div className="toc-contents">
            <div className="toc-title">Docs</div>
            <div className="toc-item">
              <Link href="/doc/overview">Overview</Link>
            </div>
            <div className="toc-item">
              <Link href="/doc/install">Installation</Link>
            </div>
              <div className="toc-item">
                <Link href="/doc/getting-started">Getting Started</Link>
              </div>
              <div className="toc-item">
                <Link href="/doc/faq">FAQ</Link>
              </div>
              <div className="toc-item">
                <Link href="/doc/archives">Download Archives</Link>
              </div>
              <div className="toc-item">Guides</div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/actions">Actions</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/selector-strategies">Auto-selectors</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/components">Components</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/custom-generators">Custom Generators</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/drafts">Drafts</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/dynamic-variables">Dynamic Variables</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/environments">Environments</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/flow-control">Flow Control</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/runs">Runs and Results</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/patchingresults">Patching Results</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/variables">Variables</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/iframes">Iframes</Link>
              </div>
              <div className="toc-item">Collaboration</div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/teams">Teams</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/invite">Invite</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/migrate">Migrate</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/team-components">Team Components</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/project-code">Project Code</Link>
              </div>
              <div className="toc-item toc-indented-item">
                - <Link href="/doc/project-groups">Project Groups and Permissions</Link>
              </div>
            </div>
          </div>
        </div>
    )
  }

}

export default DocToc;



// WEBPACK FOOTER //
// ./src/components/blog/DocToc.js